import { normalize } from 'normalizr';
import { query } from '@/dex-shared/helpers/graphql';
import {
  essayReply,
  correction,
  question,
} from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_CORRECTING({ commit, rootState }: any) {
    const response = await query(
      `query GetCorrectingEssays($userId: Int!) {
      allEssayReplies(condition: {
        status: "CORRECTING"
        userId: $userId
      }) {
        nodes {
          id
          position
          status
          questionByQuestionId {
            id
            title
            slug
            examModeByExamModeId {
              id
              name
            }
          }
        }
      }
    }`,
      {
        userId: +rootState.auth.user.id,
      },
    );
    const normalizedResponse = normalize(response.data.allEssayReplies, {
      nodes: [essayReply],
    });
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
  async PULL_CORRECTED({ commit, rootState }: any) {
    const response = await query(
      `query GetCorrectedEssays($userId: Int!) {
        correctedEssays: allEssayRepliesList(condition: {userId: $userId, status: "CORRECTED"}) {
          corrections: correctionsByEssayReplyIdList(orderBy: ID_DESC, first: 1) {
            id
            score
            finalizedAt
            examModeByExamModeId {
              id
              name
              maxScore
            }
            essayReplyByEssayReplyId {
              id
              status
              position
              questionByQuestionId {
                id
                title
                slug
                examModeByExamModeId {
                  id
                  name
                }
              }
            }
          }
        }
      }`,
      {
        userId: +rootState.auth.user.id,
      },
    );
    let nodes = [];
    response.data.correctedEssays.forEach(correctedEssay => {
      if (
        correctedEssay &&
        correctedEssay.corrections &&
        correctedEssay.corrections.length
      ) {
        nodes.push(correctedEssay.corrections[0]);
      }
    });
    const allCorrections = { nodes };

    const normalizedResponse = normalize(allCorrections, {
      nodes: [correction],
    });
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
  async PULL_CORRECTION({ commit, rootState }: any, { slug, position }: any) {
    const response = await query(
      `query GetCorrection($slug: String!, $position: Int!, $userId: Int!){
      questionBySlug(slug: $slug) {
        id
        title
        slug
        createdAt
        averageScore
        essayRepliesByQuestionId(condition: {
          userId: $userId
          position: $position
        }) {
          nodes {
            id
            status
            position
            questionId
            contentsByEssayReplyId {
              nodes {
                id
                position
                essayReplyId
                textByTextId {
                  id
                  source
                  body
                  alignment
                }
                imageByImageId {
                  id
                  url
                  source
                  resizeFactor
                  description
                  alt
                }
                videoByVideoId {
                  id
                  providerType
                  providerId
                  source
                }
              }
            }
            correctionsByEssayReplyId(orderBy: ID_DESC) {
              nodes {
                id
                score
                comment
                finalizedAt
                essayReplyId
                goalByGoalId {
                  id
                  title
                }
                correctionScoresByCorrectionId {
                  nodes {
                    id
                    score
                    comment
                    correctionId
                    correctionCriteriaByCorrectionCriteriaId {
                      id
                      maxScore
                      ltreeKnowledgeByKnowledgeId {
                        id
                        name
                      }
                    }
                    annotationsByCorrectionScoreId {
                      nodes {
                        id
                        coordinates
                        positive
                        correctionScoreId
                        contentsByAnnotationId {
                          nodes {
                            id
                            position
                            annotationId
                            textByTextId {
                              id
                              source
                              body
                              alignment
                            }
                            imageByImageId {
                              id
                              url
                              source
                              resizeFactor
                              description
                              alt
                            }
                            videoByVideoId {
                              id
                              providerType
                              providerId
                              source
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
      {
        slug,
        position,
        userId: +rootState.auth.user.id,
      },
    );
    const normalizedResponse = normalize(
      response.data.questionBySlug,
      question,
    );
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },
};
